export const uploadImage = process.env.PUBLIC_URL + '/assets/images/upload.png';
export const photo_blue = process.env.PUBLIC_URL + "/assets/images/photo-blue.svg";
export const defaultVideo = process.env.PUBLIC_URL + "/assets/images/video.jpg";
export const defaultPdf = process.env.PUBLIC_URL + "/assets/images/pdf.png";
export const logo = process.env.PUBLIC_URL + "/assets/images/logo.png";
export const Logo = process.env.PUBLIC_URL + "/assets/images/fevicon.png";
export const docsImage = process.env.PUBLIC_URL + "/assets/images/docs.png"